export type BoxStatusTone = 'success' | 'warning';

export interface BoxStatusNotice {
  tone: BoxStatusTone;
  message: string;
}

// Resolved case -> panel-owned ES copy + tone. The map is deliberately PARTIAL: the no-banner
// outcomes and any value the panel does not know fall through to null, so the notice stays quiet
// instead of guessing a tone. Fail closed — the inverse of the status chips' fail-open, because a
// decision-support notice that guesses is worse than one that says nothing.
// TODO: i18n — copy en ES hasta Fase 1.
const NOTICES: Record<string, BoxStatusNotice> = {
  free_no_subsequent: {
    tone: 'success',
    message: 'El buzón está libre y ninguna entrega lo ha ocupado después de esta.',
  },
  occupied_by_other: {
    tone: 'warning',
    message: 'El buzón está ocupado por otra entrega.',
  },
  free_with_subsequent: {
    tone: 'warning',
    message: 'El buzón está libre, pero otras entregas lo han ocupado después de esta.',
  },
  reserved_for_other_no_subsequent: {
    tone: 'warning',
    message: 'El buzón está reservado para otra entrega.',
  },
  reserved_for_other_with_subsequent: {
    tone: 'warning',
    message:
      'El buzón está reservado para otra entrega y otras entregas lo han ocupado después de esta.',
  },
};

export function boxStatusNotice(resolvedCase: string): BoxStatusNotice | null {
  // Own-property only: the case is wire data, and a bare `NOTICES[case]` also resolves inherited
  // names — `constructor` would come back truthy and put an empty banner in the decision slot,
  // which is the opposite of failing closed.
  if (!Object.hasOwn(NOTICES, resolvedCase)) return null;
  return NOTICES[resolvedCase] ?? null;
}
